import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankService {


  url = environment.serverAPI5 + "/api/bank"; 

  url1 = environment.serverAPI5 + "/api/particularbank/dropdown"; 
  
  constructor(private http: HttpClient) { }

  getAllBank(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllBankDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getBankDropDownById(warehouse: number): Observable<Object> {
    return this.http.get(`${this.url1}/${warehouse}`);
  }

  getBankById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditbank(bank: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, bank);
  }

  bankSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByBankId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}
 
  addCreditBank(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/addAmount`, warehouses);
  }

  addTransferToBank(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/transfer`, warehouses);
  }


 

}
